//@flow

import React, { useContext, useEffect } from "react";
import { Field, useField } from "react-final-form";
import type { FieldRenderProps } from "react-final-form";

import { Error, Dropdown, Row } from "modules/ChangeServiceForm/components/shared/CommonComponents";
import * as Options from "Commons/Components/FormComponents/components/DateSelect/Options";
import { required } from "modules/ChangeServiceForm/misc/validations";

import ChangeServiceFormSharedContext from "modules/ChangeServiceForm/misc/context";

type Props = {
  fieldName: string,
};

const DatePicker = ({ fieldName }: Props) => {
  const desiredDateDayFieldName = fieldName + "Day";
  const desiredDateMonthFieldName = fieldName + "Month";
  const desiredDateYearFieldName = fieldName + "Year";

  const desiredDate = useField(fieldName);
  const desiredDateDay = useField(desiredDateDayFieldName);
  const desiredDateMonth = useField(desiredDateMonthFieldName);
  const desiredDateYear = useField(desiredDateYearFieldName);

  useEffect(() => {
    if (desiredDateDay.input.value && desiredDateMonth.input.value && desiredDateYear.input.value) {
      desiredDate.input.onChange(
        formatdate(desiredDateDay.input.value, desiredDateMonth.input.value, desiredDateYear.input.value)
      );
    }
  }, [desiredDateDay, desiredDateMonth, desiredDateYear]);

  const {
    inheritedStyles: { formRow, errorMessage },
  } = useContext(ChangeServiceFormSharedContext);

  const startYear = new Date().getFullYear();
  const yearOptions = Options.getYears({ startYear, numYears: 3 }).reverse();
  const monthOptions = Options.monthNames;
  const daysOptions = Options.days;

  const formatdate = (day, month, year) => {
    return `${year}-${("0" + month).slice(-2)}-${("0" + day).slice(-2)}`;
  };

  return (
    <>
      <Field name={fieldName} validate={required}>
        {({ input: { onChange, value }, meta }: FieldRenderProps) => {
          return (
            <>
              <Row className={formRow}>
                <Field name={desiredDateDayFieldName}>
                  {({ input: { onChange, value }, meta }: FieldRenderProps) => {
                    return (
                      <Dropdown fullWidth placeholder="Tag" options={daysOptions} onChange={onChange} value={value} />
                    );
                  }}
                </Field>
              </Row>
              <Row className={formRow}>
                <Field name={desiredDateMonthFieldName}>
                  {({ input: { onChange, value }, meta }: FieldRenderProps) => {
                    return (
                      <Dropdown
                        fullWidth
                        placeholder="Monat"
                        options={monthOptions}
                        onChange={onChange}
                        value={value}
                      />
                    );
                  }}
                </Field>
              </Row>

              <Row className={formRow}>
                <Field name={desiredDateYearFieldName}>
                  {({ input: { onChange, value }, meta }: FieldRenderProps) => {
                    return (
                      <Dropdown fullWidth placeholder="Jahr" options={yearOptions} onChange={onChange} value={value} />
                    );
                  }}
                </Field>
              </Row>
            </>
          );
        }}
      </Field>
      <Error name={fieldName} className={errorMessage} />
    </>
  );
};

export default DatePicker;
